/**
 * The key rule of a roving radio group, written once: ArrowRight and
 * ArrowDown check the next card, ArrowLeft and ArrowUp the previous, both
 * wrapping, and the focus follows the check. Space, Enter and a click are
 * the radio's own press.
 */

export type RadioStep = -1 | 0 | 1;

/** What an arrow key does: 1 forward, -1 back, 0 for any other key. */
export function radioStep(key: string): RadioStep {
  if (key === 'ArrowRight' || key === 'ArrowDown') return 1;
  if (key === 'ArrowLeft' || key === 'ArrowUp') return -1;
  return 0;
}

/** The card an arrow lands on, wrapping at both ends. From no checked
 *  card (index -1), a step forward is the first card and a step back the
 *  last. */
export function nextRadioIndex(index: number, step: RadioStep, count: number): number {
  if (count <= 0) return -1;
  if (index < 0) return step < 0 ? count - 1 : 0;
  return (index + step + count) % count;
}
